import { createStyles, Loader } from "@mantine/core";

const useStyles = createStyles(() => ({
  container: {
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 1000,
    display: "grid",
    placeItems: "center",
    height: "100vh",
    width: "100vw",
    background: "var(--background-primary)",
  },
}));

const Backdrop: React.FC = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <Loader size="md" color="white" />
    </div>
  );
};

export default Backdrop;
